import { render } from "./OpenTicket.vue?vue&type=template&id=2deda274"
import script from "./OpenTicket.vue?vue&type=script&lang=js"
export * from "./OpenTicket.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/HelpDesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__